import React, { useEffect, useState } from "react";
import { CFlatList } from "@app/components/Common";
import { WorldRankingSectorSetion } from "../styles";
import { loadData } from "@utils/api";
import RankingSelectorItem from "./RankingSelectorItem";

import WorldRankingTableHeader from "../WorldRankingTableHeader";
import { useTranslation } from "react-i18next";

const RankingSectors = () => {
  const { t } = useTranslation();
  const [data, setData] = useState<any[]>([]);

  useEffect(() => {
    loadData().then((res) => {
      const slice = res.slice(0, 20);
      setData(slice);
    });
  }, []);

  const renderItem = (item: any, index: any) => {
    return <RankingSelectorItem item={item} index={index} />;
  };

  const rankingHeader = [
    "#",
    t("sector"),
    t("noOfGainersLosers"),
    t("totalMarketCap"),
    t("24hTradingVolume"),
    t("24HAverageChange"),
    t("topGainer"),
    t("action"),
  ];
  return (
    <WorldRankingSectorSetion>
      <WorldRankingTableHeader data={rankingHeader} />
      <CFlatList data={data} renderItem={renderItem} itemSize={60} />
    </WorldRankingSectorSetion>
  );
};

export default React.memo(RankingSectors);
